// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-environment-sticker[data-v-38f80845]{width:70px;height:70px;position:fixed;display:flex}.v-environment-sticker__bottomRight[data-v-38f80845]{bottom:0;right:0}.v-environment-sticker__bottomLeft[data-v-38f80845]{bottom:0;left:0}", ""]);
// Exports
module.exports = exports;
